const CARDS_DOMAIN = 'cards'
const CARDS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const CARDS_ENDPOINT = {
  GET: '/customer/getCards'
}

export {
  CARDS_DOMAIN,
  CARDS_ENDPOINT,
  CARDS_STATE
}
